/* eslint-disable import/no-mutable-exports */
var progressPanel = {
  init: function (stickybits) {
    if( $('body').hasClass('vorhaben-detail') && $('.progress-panel-wrapper').length > 0 ){
      stickybits('.progress-panel-wrapper', { useStickyClasses: true , stickyBitStickyOffset: 260 });
    }
  }
};

export default progressPanel;